import { Box } from '@mui/material'
import AssistantMessageFeedbackActions from './AssistantMessageFeedbackActions'
import AssistantMessageVersionNav from './AssistantMessageVersionNav'
import styles from './index.module.scss'

export default function AssistantMessageContentActions(props) {
  const {
    showVersionNav,
    versionLabel,
    onPrevVersion,
    onNextVersion,
    prevDisabled,
    nextDisabled,
  } = props

  return (
    <Box className={styles.actions} aria-label="Message actions">
      {showVersionNav ? (
        <AssistantMessageVersionNav
          versionLabel={versionLabel}
          onPrevVersion={onPrevVersion}
          onNextVersion={onNextVersion}
          prevDisabled={prevDisabled}
          nextDisabled={nextDisabled}
        />
      ) : null}
      <AssistantMessageFeedbackActions {...props} />
    </Box>
  )
}
